export default ({ request }) => ({
    ecomAmzFtyNoticeOutListingApi(data = {}) {
        return request({
            url: '/ecom/amz/fty/notice/out/listing',
            method: 'POST',
            data,
        })
    },
})
